// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Options/AuthorizationFieldOptions.proto (syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { TimeTrackingRole } from "../Enumerations/TimeTrackingRole_pb";
import { file_Enumerations_TimeTrackingRole } from "../Enumerations/TimeTrackingRole_pb";

/**
 * Describes the file Options/AuthorizationFieldOptions.proto.
 */
export const file_Options_AuthorizationFieldOptions: GenFile = /*@__PURE__*/
  fileDesc("CidPcHRpb25zL0F1dGhvcml6YXRpb25GaWVsZE9wdGlvbnMucHJvdG86dAoOY2xlYXJfZm9yX3JvbGUSHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGIjc+QEgAygOMiwudGltZV90cmFja2luZy5lbnVtZXJhdGlvbnMuVGltZVRyYWNraW5nUm9sZVIMY2xlYXJGb3JSb2xlQiSqAiFNb2dpLlRpbWVUcmFja2luZy5Db21tb24uTWVzc2FnZXNiBnByb3RvMw", [file_google_protobuf_descriptor, file_Enumerations_TimeTrackingRole]);

/**
 * Specifies that a field should be cleared to the default value when a user possess one of the given roles.
 *
 * @generated from extension: repeated time_tracking.enumerations.TimeTrackingRole clear_for_role = 4091400;
 */
export const clear_for_role: GenExtension<FieldOptions, TimeTrackingRole[]> = /*@__PURE__*/
  extDesc(file_Options_AuthorizationFieldOptions, 0);

